import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Modal from './Modal';
import IbsFormSubmissionDetail from './IbsFormSubmissionDetail';

function IbsFormSubmissions() {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState(null);
  const [viewingSubmissionId, setViewingSubmissionId] = useState(null);

  const fetchSubmissions = async (pageNum = 1) => {
    setLoading(true);
    try {
      const response = await api.getIbsFormSubmissions(pageNum, 20, null, null, search);
      setSubmissions(response.items || []);
      setTotalPages(response.total_pages || 0);
      setPage(pageNum);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubmissions(1);
  }, [search]);

  return (
    <div className="content-section">
      <h1>IBS Form Submissions</h1>

      {error && <div className="error-message">{error}</div>}

      <div className="toolbar">
        <input
          type="text"
          placeholder="Search submissions..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Submission ID</th>
                <th>User</th>
                <th>Bộ câu hỏi</th>
                <th>Complete</th>
                <th>Answers</th>
                <th>Submitted</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {submissions.map((sub) => (
                <tr key={sub.id}>
                  <td>{sub.id}</td>
                  <td>{sub.user_full_name || sub.username}</td>
                  <td>{sub.form_name}</td>
                  <td>{sub.is_complete ? '✓' : '-'}</td>
                  <td>{sub.answer_count}</td>
                  <td>{sub.submitted_at ? new Date(sub.submitted_at).toLocaleDateString() : '-'}</td>
                  <td>
                    <button
                      className="btn btn-small btn-secondary"
                      onClick={() => setViewingSubmissionId(sub.id)}
                    >
                      Xem chi tiết
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination">
            <button
              onClick={() => fetchSubmissions(page - 1)}
              disabled={page <= 1}
              className="btn btn-small"
            >
              Previous
            </button>
            <span>Page {page} of {totalPages}</span>
            <button
              onClick={() => fetchSubmissions(page + 1)}
              disabled={page >= totalPages}
              className="btn btn-small"
            >
              Next
            </button>
          </div>
        </>
      )}

      {viewingSubmissionId != null && (
        <Modal title="Chi tiết bài làm IBS" onClose={() => setViewingSubmissionId(null)}>
          <IbsFormSubmissionDetail submissionId={viewingSubmissionId} />
        </Modal>
      )}
    </div>
  );
}

export default IbsFormSubmissions;
